export default "__VITE_ASSET__Dy$GAUZu__"